// extracted by mini-css-extract-plugin
module.exports = {"list":"styles-module__list___cs5Qd","item":"styles-module__item___Qkf3k"};